/**
 * Build GA4 `ecommerce.items` arrays from cart state. `value` at checkout time
 * should remain the full total from `buildTicketFees` (includes fees/tax); line
 * `price` here is face / unit amount before fee allocation.
 */

export function ga4ItemsFromTicketQuantities(ticketQuantities, ticketinventory) {
  const items = [];
  if (!ticketinventory || !ticketQuantities) return items;

  for (const name of Object.keys(ticketQuantities)) {
    const quantity = ticketQuantities[name];
    if (!quantity || quantity < 1) continue;

    const ticket = ticketinventory.find((t) => t.ticketName === name);
    const itemId = ticket?._id != null ? String(ticket._id) : String(name);

    items.push({
      item_id: itemId,
      item_name: String(name),
      item_category: "ticket",
      price: Number(ticket?.price ?? 0),
      quantity: Number(quantity),
    });
  }
  return items;
}

/**
 * @param {string[]} selectedSeatIds
 * @param {{ ticketName: string, price: number }[]} pricedLines same order as `selectedSeatIds` in cart total logic
 */
export function ga4ItemsFromSeatingLines(selectedSeatIds, pricedLines) {
  if (!selectedSeatIds?.length || !pricedLines?.length) return [];

  return selectedSeatIds
    .map((seatKey, i) => {
      const line = pricedLines[i];
      if (!line) return null;
      return {
        item_id: String(seatKey),
        item_name: String(line.ticketName),
        item_category: "ticket",
        price: Number(line.price),
        quantity: 1,
      };
    })
    .filter(Boolean);
}
